import { Button, Modal, Space } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import TicketPoolForm from "../TicketPoolForm";

import TicketTemplatePickerForm from "./partials/TicketTemplatePickerForm";
import { TicketPoolListFieldProps } from "./types";
import { useTicketPoolListField } from "./hooks";
import TicketPoolsTable from "./partials/TicketPoolsTable";

const TicketPoolListField: React.FC<TicketPoolListFieldProps> = (props) => {
  const { eventDate, allowAddFromTicketTemplate, asSignUpOptions } = props;
  const {
    table,
    modal,
    form,
    onAdd,
    ticketTemplateModal,
    onTicketTemplateAdd,
    ticketTemplatePickerForm,
  } = useTicketPoolListField(props);

  return (
    <>
      <Header>
        <Space>
          <Button type="primary" htmlType="button" onClick={onAdd}>
            {asSignUpOptions ? (
              <FormattedMessage defaultMessage="Add Variant" />
            ) : (
              <FormattedMessage defaultMessage="Add Ticket Type" />
            )}
          </Button>
          {allowAddFromTicketTemplate && (
            <Button
              type="primary"
              htmlType="button"
              onClick={onTicketTemplateAdd}
            >
              <FormattedMessage defaultMessage="Add from Ticket Template" />
            </Button>
          )}
        </Space>
      </Header>
      <TicketPoolsTable {...table} />
      <Modal
        title={
          asSignUpOptions ? (
            <FormattedMessage defaultMessage="Sign up Option Variant" />
          ) : (
            <FormattedMessage defaultMessage="Ticket Variant" />
          )
        }
        footer={null}
        width={700}
        destroyOnClose
        {...modal}
      >
        <TicketPoolForm {...{ ...form, eventDate, asSignUpOptions }} />
      </Modal>
      <Modal
        title={<FormattedMessage defaultMessage="Add ticket from template" />}
        footer={null}
        width={960}
        destroyOnClose
        {...ticketTemplateModal}
      >
        <TicketTemplatePickerForm {...ticketTemplatePickerForm} />
      </Modal>
    </>
  );
};

export default TicketPoolListField;
